<template>
    <v-app>
        <v-navigation-drawer width="419" :app="!isMobile" permanent v-if="toggle || !isMobile">
            <v-list-item two-line class="pl-12 green white--text nav-top" style="height: 90px" :to="{name : 'AdminProfile'}" @click="toggle = false">
                <v-list-item-avatar :size="isMobile ? 30 : 66">
                    <v-img :src="ADMIN_USER.avatar || require('@/../public/images/Avatar.png')"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>{{ `${ADMIN_USER.name} ${ADMIN_USER.sur_name}` }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list class="py-0">
                <v-list-item class="pl-12 py-3" :to="{name : 'AdminBlog'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-home'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>Home</v-list-item-title>
                </v-list-item>

                <v-divider class="green"></v-divider>

                <v-list-group class="pl-8 py-3" :active-class="isMobile ? 'white--text' : 'green--text'">
                    <template v-slot:prependIcon>
                        <svg v-svg="'icon-users'" size="24"></svg>
                    </template>

                    <template v-slot:activator>
                        <v-list-item-title>Users</v-list-item-title>
                    </template>

                    <v-list-item class="pl-6" :to="{name : 'AdminRegistrations'}" @click="toggle = false">
                        <v-list-item-icon>
                            <svg v-svg="'icon-registrations'" size="24"></svg>
                        </v-list-item-icon>

                        <v-list-item-title>Registrations</v-list-item-title>
                    </v-list-item>

                    <v-list-item class="pl-6" :to="{name : 'AdminStudents'}" @click="toggle = false">
                        <v-list-item-icon>
                            <svg v-svg="'icon-students'" size="24"></svg>
                        </v-list-item-icon>

                        <v-list-item-title>Students</v-list-item-title>
                    </v-list-item>

                    <v-list-item class="pl-6" :to="{name : 'AdminTeachers'}" @click="toggle = false">
                        <v-list-item-icon>
                            <svg v-svg="'icon-teachers'" size="24"></svg>
                        </v-list-item-icon>

                        <v-list-item-title>Teachers</v-list-item-title>
                    </v-list-item>
                </v-list-group>

                <v-divider class="green mb-2"></v-divider>

                <v-list-item class="pl-12" :to="{name : 'AdminTeams'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-teams'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>Teams</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'AdminSubjects'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-subjects'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>Subjects</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'AdminHomework'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-homework'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>Homework</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'AdminResults'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-results'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>Results</v-list-item-title>
                </v-list-item>

                <v-list-item class="pl-12" :to="{name : 'AdminHelp'}" @click="toggle = false">
                    <v-list-item-icon>
                        <svg v-svg="'icon-help'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>Help</v-list-item-title>
                </v-list-item>

                <v-divider class="green mt-2"></v-divider>

                <v-list-item class="pl-12 py-3" @click="logoutAdmin()">
                    <v-list-item-icon>
                        <svg v-svg="'icon-logout'" size="24"></svg>
                    </v-list-item-icon>

                    <v-list-item-title>Log out</v-list-item-title>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <p class="ml-12 mb-5 font-weight-bold black--text">&copy; {{ new Date().getFullYear() }} TCO TEAM.</p>
            </template>
        </v-navigation-drawer>

        <v-app-bar height="90" app color="white">
            <v-app-bar-nav-icon class="ml-3" :to="{name : 'AdminBlog'}">
                <v-img :src="require('@/../public/images/icons/TCO.png')"/>
            </v-app-bar-nav-icon>
            <v-spacer v-if="isMobile"></v-spacer>
            <h2 class="green--text font-weight-bold pl-3">{{APP_NAME.toUpperCase()}} - ADMIN DASHBOARD</h2>
            <v-spacer v-if="isMobile"></v-spacer>
            <v-app-bar-nav-icon class="mr-3" v-if="isMobile" @click="toggle = !toggle">
                <svg v-svg="'icon-open-nav'" size="28 21" v-if="!toggle"></svg>
                <svg v-svg="'icon-close-nav'" size="28 21" v-else></svg>
            </v-app-bar-nav-icon>
        </v-app-bar>

        <v-main v-show="!toggle">
            <v-container fluid>
                <slot></slot>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        data: () => ({ isMobile: false, toggle: false }),

        mounted() {
            this.onResize();
            window.addEventListener('resize', this.onResize, { passive: true });
        },

        beforeDestroy() {
            if (typeof window === 'undefined') return;
            window.removeEventListener('resize', this.onResize, { passive: true });
        },

        methods: {
            logoutAdmin() {
                this.$store.dispatch('LOGOUT_ADMIN');
                this.$router.push({name : 'AdminLogin'});
            },

            onResize() {
                this.isMobile = window.innerWidth < 1264
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/layouts/index";
</style>